// ─── widgets/container.js ─────────────────────────────────────────────────────
// Creates cleverstory.v2.widgets.container objects.

import shortid from 'shortid';
import { cs, getAbsoluteRect } from '../utils/dom.js';
import {
    extractRGBAFromColor,
    extractBorderRadius,
    extractSectionBackground,
    extractShadowProperties,
} from '../utils/style.js';
import { CONTAINER } from 'constants/widgetTypes.jsx';

function extractPadding(style) {
    return parseFloat(style.paddingTop) || 0;
}

function extractBorder(style) {
    const borderWidth = parseFloat(style.borderWidth || '0');
    const normalizedWidth = borderWidth > 0 && borderWidth < 1 ? 1 : borderWidth;
    return {
        sides:  null,
        color:  extractRGBAFromColor(style.borderColor),
        width:  normalizedWidth.toString(),
        radius: extractBorderRadius(style),
    };
}

/**
 * @param {{ el, mobileEl, parentUid, offsetRect, mobileOffsetRect, orderRef, doc }}
 */
export function createContainerWidgetObj({ el, mobileEl, parentUid, offsetRect, mobileOffsetRect, orderRef, doc }) {
    const style  = cs(el);
    const rect   = getAbsoluteRect(el);
    const mRect  = mobileEl
        ? getAbsoluteRect(mobileEl)
        : { width: Math.min(rect.width, 335), height: rect.height, top: rect.top, left: Math.min(rect.left, 20) };

    const mOff = mobileOffsetRect || offsetRect;
    const cx   = Math.round(rect.left  - (offsetRect.left || 0));
    const cy   = Math.round(rect.top   - (offsetRect.top  || 0));
    const mcx  = Math.round(mRect.left - (mOff.left || 0));
    const mcy  = Math.round(mRect.top  - (mOff.top  || 0));

    const background = extractSectionBackground(style, el, doc);
    const border     = extractBorder(style);
    const shadow     = extractShadowProperties(style.boxShadow);
    const padding    = extractPadding(style);
    const mPadding   = mobileEl ? extractPadding(cs(mobileEl)) : padding;

    return {
        uid:           `widget_${shortid.generate()}`,
        type:          CONTAINER,
        name:          'Container',
        parent:        parentUid,
        order:         orderRef.value++,
        systemDefined: false,
        fonts:         null,
        actions:       null,
        parameter:     null,
        properties: {
            desktop: {
                visible: true,
                layout: {
                    transform: { translate: `${cx}px,${cy}px`, rotate: '0deg', scale: '1,1' },
                    width:  Math.round(rect.width)  + 'px',
                    height: Math.round(rect.height) + 'px',
                },
                padding,
                background,
                border,
                shadow,
            },
            mobile: {
                visible: true,
                layout: {
                    transform: { translate: `${mcx}px,${mcy}px`, rotate: '0deg', scale: '1,1' },
                    width:  Math.round(mRect.width)  + 'px',
                    height: Math.round(mRect.height) + 'px',
                },
                padding:    mPadding,
                background: null,
                border:     null,
                shadow:     null,
            },
        },
        content: null,
    };
}
